// extracted by mini-css-extract-plugin
export default {"loginCard":"LoginCard_loginCard__AZyeq","loginOptionContainer":"LoginCard_loginOptionContainer__mqbEc","teamLabelContainer":"LoginCard_teamLabelContainer__tKqhs"};